import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class PrescriptionStore extends LocalModel {
    constructor() {
        super('prescription', {
            namePlural: 'prescriptions',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/prescriptions/',
                    params: {
                        limit: 15,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/prescriptions/',
                    params: {},
                },
                save: {
                    url: '/api/prescriptions/',
                    params: {},
                },
                delete: {
                    url: '/api/prescriptions/',
                    params: {},
                },
            },
        });
    }

    @observable newPrescription = {};

    @observable prescription = {};

    @observable prescriptions = [];

    @observable veterinaries = [];

    async loadVeterinaries() {
        const response = await util.fetchApi(`/api/users/veterinaries/`, { method: 'GET' }, {});
        switch (response.status) {
            case 200:
                this.updateKeyValue('veterinaries', response.data);
                return response;

        }
    }

    async emailPrescription(id, email, visitorId, animalId, journalId, saleId, comment, code) {
        const response = await util.fetchApi(`/api/prescriptions/${id}/email`, { method: 'POST' }, {
            email,
            visitorId,
            animalId,
            journalId,
            saleId,
            comment,
            code,
        });
        switch (response.status) {
            case 200:
                return response;

        }
    }

    // AI prescription assistant (featureFlags.aiPrescription). Each method returns the
    // raw API response ({ status, message, data }) so the component can branch on status.
    async aiProposal({ animalId, journalId, currentDrugs = [] }) {
        try {
            return await util.fetchApi('/api/prescriptions/ai-proposal', { method: 'POST' }, {
                animalId,
                journalId,
                currentDrugs,
            });
        } catch (err) {
            console.error('aiProposal failed:', err);
            return { status: 500, message: 'AI-tjenesten svarte ikke.' };
        }
    }

    async aiCheck({ animalId, journalId, drugs = [] }) {
        try {
            return await util.fetchApi('/api/prescriptions/ai-check', { method: 'POST' }, {
                animalId,
                journalId,
                drugs,
            });
        } catch (err) {
            console.error('aiCheck failed:', err);
            return { status: 500, message: 'Sjekk utilgjengelig.' };
        }
    }

    async aiFeedback({ claudeLogId, rating = 0, acceptedLIds = [], comment = '' }) {
        try {
            return await util.fetchApi('/api/prescriptions/ai-feedback', { method: 'POST' }, {
                claudeLogId,
                rating,
                acceptedLIds,
                comment,
            });
        } catch (err) {
            console.error('aiFeedback failed:', err);
            return { status: 500 };
        }
    }
}

const store = new PrescriptionStore();
export default store;
